/**
 * Inspired in https://github.com/codejamninja/idempotent-babel-polyfill
 *
 * Allows to require babel polyfill only if it hasn't loaded yet.
 * Useful for views where 3rd party plugins could contain its own babel polyfill copy.
 * A good example would be any Splash Page with the TypeForm widget.
 */

if (!window._babelPolyfill) {
    // eslint-disable-next-line global-require
    require('@babel/polyfill');
}
